import { Button, Tr, Td } from '@chakra-ui/react';
import { Formik, FormikProps } from 'formik';
import React from 'react';

import {
  finleyAssertUnreachable,
  utils as commonUtils,
} from '@finley-technologies/common';
import { CreditAgreement } from '@finley-technologies/finley-types';

import { colors } from 'packages/common-frontend/colors';
import { SelectFormField } from 'packages/common-frontend/components/FormField';
import { formatSelectOptions } from 'packages/common-frontend/components/Select';

export type CalcAgentConfigKeyType = keyof CreditAgreement.Config.ResolvedCalcAgentMechanicsConfig;
export type PropertyValueTypes = CreditAgreement.Config.ConcentrationLimit.Calculation.KickoutMethod;

const concentrationKickoutMethods: CreditAgreement.Config.ConcentrationLimit.Calculation.KickoutMethod[] = [
  'waterfall',
  'nonIterative',
];
const ConcentrationKickoutMethodOptions = formatSelectOptions(
  concentrationKickoutMethods,
  'title',
);
const EditConcentrationKickoutMethodProperty = () => {
  return (
    <SelectFormField
      name="value"
      label="Concentration Kickout Method"
      options={ConcentrationKickoutMethodOptions}
    />
  );
};

type EditPropertyManagerProps = { propertyKey: CalcAgentConfigKeyType };
const EditPropertyManager = ({ propertyKey }: EditPropertyManagerProps) => {
  switch (propertyKey) {
    case 'concentrationKickoutMethod':
      return <EditConcentrationKickoutMethodProperty />;
    default:
      return finleyAssertUnreachable(propertyKey);
  }
};

type EditCalcAgentConfigRowProps = {
  propertyKey: CalcAgentConfigKeyType;
  initialProperty: PropertyValueTypes;
  onSave: (input: {
    propertyKey: CalcAgentConfigKeyType;
    value: PropertyValueTypes;
  }) => void;
  onCancel: () => void;
  setIsEditMode: React.Dispatch<React.SetStateAction<boolean>>;
};
export const EditCalcAgentConfigRow = ({
  propertyKey,
  initialProperty,
  onSave,
  onCancel,
  setIsEditMode,
}: EditCalcAgentConfigRowProps) => {
  return (
    <Formik
      initialValues={{ value: initialProperty }}
      onSubmit={(props) => {
        onSave({ propertyKey, value: props.value });
        setIsEditMode(false);
      }}
    >
      {(formProps: FormikProps<{ value: PropertyValueTypes }>) => (
        <Tr>
          <Td>{commonUtils.toTitleCase(propertyKey)}</Td>
          <Td>
            <EditPropertyManager propertyKey={propertyKey} />
          </Td>

          <Td verticalAlign="top">
            <Button
              display="block"
              w="100%"
              mt="28px"
              mb="16px"
              color="white"
              backgroundColor={colors.aurora[400]}
              type="submit"
              onClick={() => formProps.handleSubmit()}
            >
              Save
            </Button>
            <Button
              display="block"
              w="100%"
              color={colors.aurora[400]}
              border="2px"
              borderRadius="8px"
              borderColor={colors.aurora[400]}
              backgroundColor="white"
              onClick={() => onCancel()}
            >
              Cancel
            </Button>
          </Td>
        </Tr>
      )}
    </Formik>
  );
};
